import { useState } from 'preact/hooks';

import clsx from 'clsx';

import { useIntl } from '@/app/lib/localization/hooks/use-intl';

import { PlayButton } from '@/entities/buttons/play-button';
import { useProgress } from '@/entities/playdeck/models/playdeck.store';
import { Preloader } from '@/entities/preloader/ui';
import { LinearProgressBar } from '@/entities/progress-bar/ui/LinearProgressBar';

import { isDesktop } from '@/shared/helpers/is-desktop';
import { useAppState } from '@/shared/stores/app-store/app-store';
import { Button } from '@/shared/ui/button/ui';

import abTestImage from '@/assets/images/plane.webp';

import { Panel } from '@/widget/panel/ui';

import s from './index.module.scss';

const MINI_GAME_URL = 'https://dick-kick-wr.good-games.xyz/';
const MINI_GAME_V2_URL = 'https://dick-kick-wr.good-games.xyz/wrapper-adult-minigame/minigame.html';
const PROGRESS_END = 100;

interface Props {
  pdOpen: boolean;
  showIntro?: boolean;
}

export const AbLoadingScreen = ({ pdOpen, showIntro = false }: Props) => {
  const [isMiniGameStarted, setMiniGameStarted] = useState(false);
  const progress = useProgress();
  const { game } = useAppState();
  const t = useIntl();

  const isLoaded = progress >= PROGRESS_END;
  const isDesktopDevice = isDesktop();
  const miniGameUrl = showIntro ? MINI_GAME_URL : MINI_GAME_V2_URL;
  const isPlaying = showIntro ? isMiniGameStarted : true;

  return (
    <>
      <Preloader pdOpen={pdOpen} />
      <div className={clsx(s.wrapper, !pdOpen && s.disappearance, isLoaded && s.loaded)}>
        <div className={s.content}>
          {game && !isDesktopDevice ? (
            <Panel game={game} pdOpen={pdOpen} titleOnly />
          ) : null}

          <div className={clsx(s['mini-game'], isPlaying && s['mini-game-playing'])}>
            {showIntro && (
              <div
                className={clsx(
                  s['mini-game-intro'],
                  isMiniGameStarted && s['mini-game-intro-hidden']
                )}
                aria-hidden={isMiniGameStarted}
              >
                <h2 className={s.title}>{t('Taking a while to load?')}</h2>
                <img src={abTestImage} className={s['ab-test-image']} alt="ab-test" />
                <p className={s.description}>{t('Play a mini game while waiting')}</p>
                <Button
                  className={s['play-button']}
                  onClick={() => setMiniGameStarted(true)}
                >
                  {t('Play')}
                </Button>
              </div>
            )}
            <div
              className={clsx(
                s['mini-game-frame-wrap'],
                isPlaying && s['mini-game-frame-wrap-visible']
              )}
              aria-hidden={!isPlaying}
            >
              <iframe
                className={s['mini-game-frame']}
                src={miniGameUrl}
                title="mini-game"
              />
            </div>
          </div>

          <div className={s.progress}>
            {isLoaded ? (
              <PlayButton className={s['play-btn']} />
            ) : (
              <>
                <div className={s.percent}>{Math.trunc(progress)}%</div>
                <LinearProgressBar value={progress} />
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
